import React, { Component, Fragment } from "react";
import { CLIENT_TOKEN, API_URL } from "../../common/constants";
import Api from "../../common/helpers/Api";
import { toast } from "react-toastify";

class ProductSuggestion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mainProduct: {},
      relatedProducts: []
    };
  }

  async componentDidMount() {
    // On definit le "main product" qui est celui pour lequel les suggestions sont definis
    // et un related
    const [mainProduct, related] = await Promise.all([
      this.getMainProduct(),
      this.getRelatedProducts()
    ]);
    this.setState({ mainProduct, relatedProducts: related.flat() });
  }

  getMainProduct() {
    return this.props.articles.filter(
      art =>
        art.productId ===
        `/${CLIENT_TOKEN}products/${this.props.suggestion.ruleOnProduct}`
    )[0];
  }

  getRelatedProducts() {
    return this.props.suggestion.relatedProducts.map(p =>
      this.props.articles.filter(
        art => art.productId === `/${CLIENT_TOKEN}products/${p}`
      )
    );
  }

  async deleteProduct(id) {
    if (!id) {
      return;
    }

    const articleId = id.split(`/${CLIENT_TOKEN}articles/`)[1];
    try {
      await Api.delete("articles/" + articleId);
    } catch (reason) {
      if (reason.response) {
        if (reason.response.status === 400) {
          return { error: "Identifiants inconnus" };
        } else {
          return { error: "Une erreur s'est produite" };
        }
      }
    }
  }

  async getProduct(id) {
    try {
      const response = await Api.get(API_URL + CLIENT_TOKEN + "products/" + id);

      const { data } = response;

      return { product: data, error: null };
    } catch (reason) {
      return { error: true };
    }
  }

  async addToCart(id) {
    // await this.setState({ productLoading: true });

    const productResponse = await this.getProduct(id);
    console.log(productResponse);

    if (productResponse.error) {
      this.setState({ error: productResponse.error, productLoading: false });
      return;
    }
    const result = await this.props.store.addProductToSale(
      productResponse.product.offers[0]
    );
    if (result.sale && result.sale["hydra:member"]) {
      toast.success("Produit ajouté au panier");
    } else {
      // this.setState({ addToCartLoading: false });
      toast.error("Une erreur s'est produite");
    }
    console.log(result);
  }

  async replaceProducts(productToAdd) {
    console.log("prod to add", productToAdd);
    await this.props.willRefreshCart();

    await this.deleteProduct(this.state.mainProduct["@id"]);

    await this.state.relatedProducts.map(async p => {
      await this.deleteProduct(p["@id"]);
    });
    await this.addToCart(productToAdd);
    this.props.refreshCart();
  }

  getMainProductToReplaceLabel() {
    return this.state.mainProduct && this.state.mainProduct.productName
      ? this.state.mainProduct.productName
      : "";
  }

  getRelatedProductsToReplaceLabels() {
    return this.props.suggestion.relatedProducts.map((p, i) => {
      const art = this.props.articles.filter(
        art => art.productId === `/${CLIENT_TOKEN}products/${p}`
      );
      let artElement = "";
      if (art && art[0]) artElement = art[0].productName;

      if (i !== this.props.suggestion.relatedProducts.length - 1)
        return (
          <Fragment key={i + artElement}>
            <strong>{artElement}</strong>et
          </Fragment>
        );
      else return <strong key={i + artElement}>{artElement}</strong>;
    });
  }

  render() {
    return (
      <div>
        <p>
          Remplacez <strong>{this.getMainProductToReplaceLabel()}</strong> et{" "}
          {this.getRelatedProductsToReplaceLabels()} par:
        </p>
        <ul>
          {this.props.suggestion.suggestions.map((s, i) => {
            return (
              <Fragment key={i + s.name}>
                <li>
                  {s.name} -{" "}
                  <a target="_blank" href={s.link}>
                    Voir le detail{" "}
                    <i className="fa fa-external-link" aria-hidden="true" />
                  </a>
                  <button
                    className="elementor-size-m elementor-animation-shrink elementor-button"
                    onClick={() => this.replaceProducts(s.id)}
                  >
                    Remplacer maintenant
                  </button>
                </li>
                {i !== this.props.suggestion.suggestions.length - 1 && (
                  <li>ou</li>
                )}
              </Fragment>
            );
          })}
        </ul>
      </div>
    );
  }
}

export default ProductSuggestion;
